const SuccessMessages = {

  // Product Success
  PRODUCT_APPROVED: "Product approved successfully.",
  PRODUCT_DETAILS_UPDATED: "Product has been updated successfully.",
  PRIMARYIMAGE_ADDED_IMAGE: "Primary image has been added successfully.",
  GALERYIMAGE_ADDED_IMAGE: "Gallery image has been added successfully.",
  SPEC_TABLE_DELETE: "Specification table data has been deleted successfully.",
  GALLERY_IMAGE_DELETED: "Product gallery image has been deleted successfully.",

  // Customer Success
  CUSTOMER_ADDED: "Member added successfully.",
  CUSTOMER_UPDATED: "Customer updated successfully.",
  CUSTOMER_DELETED: "Customer deleted successfully.",

  // Pincode Success
  PINCODE_ADDED: "Store pincode has been added successfully.",
  PINCODE_DELETED: "Store pincode has been deleted successfully.",

  // membership
  MEMBERSHIP_ACTIVATE:"Prime membership activated successfully.",

  // generate key
  KEY_GENERATE: "Keys has been generated successfully.",
  DELETE_KEY: "Key has been deleted successfully.",

  // referral offer Product
  REFERRAL_OFFER_PRODUCT_ADDED: "Referral offerhas been added successfully.",
  REFERRAL_OFFER_PRODUCT_DELETED:
    "Referral offer has been deleted successfully.",
  REFERRAL_OFFER_PRODUCT_UPDATED:
    "Referral offer has been updated successfully.",

  // Category Success
  CATEGORY_ADDED: "Category added successfully.",
  CATEGORY_UPDATED: "Category updated successfully.",
  CATEGORY_DELETED: "Category deleted successfully.",
  CATEGORY_IMAGE: "Category image has been uploaded successfully.",

  // MainCategory Success
  MAINCATEGORY_ADDED: "MainCategory added successfully.",
  MAINCATEGORY_UPDATED: "MainCategory updated successfully.",
  MAINCATEGORY_ADDED_DELETED: "MainCategory deleted successfully.",
  MAINCATEGORY_ADDED_IMAGE:
    "Maincategory image has been uploaded successfully.",

  // SubCategory Success
  SUBCATEGORY_ADDED: "SubCategory added successfully.",
  SUBCATEGORY_UPDATED: "SubCategory updated successfully.",
  SUBCATEGORY_DELETED: "Subcategory has been deleted successfully..",
  SUBCATEGORY_ADDED_IMAGE: "Subcategory image has been uploaded successfully.",

  // Slider Success
  SLIDER_ADDED: "Slider has been added successfully.",
  SLIDER_UPDATED: "Slider has been updated successfully.",
  SLIDER_DELETED: "Slider has been deleted successfully.",
  SLIDER_IMAGE_UPDATED: "Slider Image Updated successfully.",

  // Deals Success
  DEALS_ADDED: "Deals added successfully.",
  DEALS_UPDATED: "Deals updated successfully.",
  DEALS_DELETED: "Deals deleted successfully.",
  DEALS_IMAGE_UPDATED: "Deals Image Updated successfully.",

  // setting
  ORDER_SETTING: "Order settings has been updated successfully.",
  DELIVERY_SETTING: "Delivery settings has been updated successfully",
  SETTING_SUCCESS: "Store settings has been updated successfully.",
  SETTING_ECOMMERCE_UPDATE: "Ecommerce settings updated successfully",
  
  // Category Success
  PRODUCT_ADD_TO_CATEGORY_ADDED: "Product added to category successfully.",

  //reward
  UPDATE_REWARD:"Wallet has been updated successfully.",
  // General Success
  OPERATION_SUCCESS: "The operation was successful.",
  DATA_FETCH_SUCCESS: "Data fetched successfully.",
  DATA_SAVE_SUCCESS: "Data saved successfully.",
  CONNECTION_RESTORED: "You are back online. Connection restored.",

  // Authentication Success
  LOGIN_SUCCESS: "Login successful. Welcome back!",
  LOGOUT_SUCCESS: "You have successfully logged out.",
  PASSWORD_RESET_SUCCESS:
    "Password reset successful. You can now log in with the new password.",

  // Email Success
  EMAIL_SENT: "Email has been sent successfully.",
  OTP_SENT: "OTP sent successfully. Please check your email.",
  EMAIL_VERIFIED: "Your email has been verified successfully.",
  INVITE_SUCCESS: "Your invitation accepted and account created successfully.",

  // OTP Success
  OTP_VERIFIED: "OTP verified successfully.",

  // File Upload Success
  FILE_UPLOADED: "File uploaded successfully.",

  // User Account Success
  ACCOUNT_CREATED: "Your account has been created successfully.",
  ACCOUNT_UPDATED: "Your account details have been updated successfully.",
  ACCOUNT_DELETED: "Your account has been deleted successfully.",

  // Product Success
  PRODUCT_ADDED: "Product added successfully.",
  PRODUCT_UPDATED: "Product updated successfully.",
  PRODUCT_DELETED: "Product deleted successfully.",
  PRODUCT_ADDED_TO_WISHLIST: "Product added to your wishlist.",
  PRODUCT_REMOVED_FROM_WISHLIST: "Product removed from your wishlist.",

  // Cart Success
  ITEM_ADDED_TO_CART: "Item added to your cart.",
  ITEM_REMOVED_FROM_CART: "Item removed from your cart.",
  CART_UPDATED: "Your cart has been updated.",

  // Order Success
  ORDER_UPDATED: "Order status has been updated successfully.",
  ORDER_PLACED: "Your order has been placed successfully.",
  ORDER_CANCELLED: "Your order has been cancelled successfully.",
  ORDER_RETURN_INITIATED: "Return request initiated successfully.",
  ORDER_DELIVERED: "Your order has been delivered successfully.",

  // Review Success
  REVIEW_SUBMITTED: "Your review has been submitted successfully.",
  REVIEW_UPDATED: "Your review has been updated successfully.",
  REVIEW_DELETED: "Your review has been deleted successfully.",

  // Shipping Success
  SHIPPING_ADDRESS_ADDED: "Shipping address added successfully.",
  SHIPPING_ADDRESS_UPDATED: "Shipping address updated successfully.",
  SHIPPING_ADDRESS_DELETED: "Shipping address deleted successfully.",

  // Discount and Offers Success
  COUPON_APPLIED: "Coupon applied successfully.",
  COUPON_REMOVED: "Coupon removed successfully.",
  DISCOUNT_APPLIED: "Discount applied successfully to your order.",

  // Notification Success
  NOTIFICATION_SUBSCRIBED: "You have successfully subscribed to notifications.",
  NOTIFICATION_UNSUBSCRIBED:
    "You have successfully unsubscribed from notifications.",

  // order
  TRANKINGID_EXIST: "Tracking ID already exists.",

  ORDER_UPDATED_FAILED: "Failed to update order status.",
  // Custom Success
  CUSTOM_SUCCESS: "Operation completed successfully.",

  FORM_SUBMITTED: "Form submitted successfully.",
};

export default SuccessMessages;
